import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import VoiceTest from "./pages/VoiceTest";
import EmailTest from "./pages/EmailTest";
import Users from "./pages/Users";
import Settings from "./pages/Settings";
import Layout from "./components/Layout";
import "./App.css";

const ProtectedRoute = ({ children, ...props }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <Route
      {...props}
      render={({ location }) =>
        user ? (
          <Layout>{children}</Layout>
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

const AppRoutes = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <Switch>
      <Route path="/login" component={Login} />
      <ProtectedRoute path="/dashboard" exact>
        <Dashboard />
      </ProtectedRoute>
      <ProtectedRoute path="/test/voice" exact>
        <VoiceTest />
      </ProtectedRoute>
      <ProtectedRoute path="/test/email" exact>
        <EmailTest />
      </ProtectedRoute>
      <ProtectedRoute path="/users">
        <Users />
      </ProtectedRoute>
      <ProtectedRoute path="/settings">
        <Settings />
      </ProtectedRoute>
      <Route path="/" exact>
        <Redirect to={user ? "/dashboard" : "/login"} />
      </Route>
    </Switch>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <AppRoutes />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
